import { render } from "./ViewTickets.vue?vue&type=template&id=2fe1335a&scoped=true"
import script from "./ViewTickets.vue?vue&type=script&lang=js"
export * from "./ViewTickets.vue?vue&type=script&lang=js"

import "./ViewTickets.vue?vue&type=style&index=0&id=2fe1335a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fe1335a"]])

export default __exports__